/** Canonical rest-space attribute shared by custom material shaders. */
export const SURFACE_REST_POSITION_ATTRIBUTE = 'surfaceRestPosition';
